import React, { useState, useContext } from 'react';
import { BsQuestionCircle } from 'react-icons/bs';
import { MdDelete } from 'react-icons/md';

import * as S from './styles';
import { color } from 'styles/pallete';
import { saveImageOnServer } from 'utils/functions';
import { useTranslation } from 'react-i18next';
import { InputImgBiggerProps } from 'types/InputImgBiggerProps';
import { UseTranslationProps } from 'types/UseTranslationProps';
import LoadGeneralContext from 'context/LoadGeneralContext';
import SystemNotifyContext from 'context/SystemNotifyContext';

export default function InputImgBigger({
	label,
	initialImage,
	getImage,
	idImagem,
	maxWidth = 9999,
	minWidth = 1,
	maxHeight = 9999,
	minHeight = 1,
	messageMinError = '',
	btnDeleteImage = false,
	imgHeight = 300,
	legendDimensionsImage = null,
	error = false,
	messagemError = 'inputImgBigger.anyError',
	doubtBox = false,
	messageDoubtBox = '',
	showMinLabel = false,
	showDelteImageFromBackBtn = false,
	functionToDeleteImgFromBack = () => {}
}: InputImgBiggerProps) {
	const { t }: UseTranslationProps = useTranslation();
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);
	const { handleNotify } = useContext(SystemNotifyContext);

	const [isShowBtnUnselect, setIsShowBtnUnselect] = useState(false);

	// Só pode enviar photo 132x132
	function savePhoto(file: any) {
		const reader = new FileReader();
		let height = 0;
		let width = 0;

		//Read the contents of Image File.
		reader.readAsDataURL(file.target.files[0]);
		reader.onload = function (e) {
			//Initiate the JavaScript Image object.
			const image: any = new Image();

			//Set the Base64 string return from FileReader as source.
			image.src = e.target!.result;

			//Validate the File Height and Width.
			image.onload = async function () {
				height = this.height;
				width = this.width;
				if (width >= minWidth && height >= minHeight) {
					if (width <= maxWidth && height <= maxHeight) {
						setIsOpenLoad(true);
						setMessage(t('inputImgBigger.savingImg'));

						const { isSuccess, photo } = await saveImageOnServer(
							file.target.files[0],
							t,
							handleNotify
						);

						if (isSuccess && photo !== null) {
							getImage(photo);
						} else {
							getImage(null);
						}

						// o if abaixo é para deletar a imagem do input para poder subir a mesma se o cliente quiser (foi add recentemente, se algo bugar apagar if abaixo)
						const inputImage: any = document.getElementById(idImagem);
						if (inputImage !== null && inputImage.files !== null) {
							inputImage.value = '';
						}
					} else {
						handleNotify(
							`${t('inputImgBigger.maxWidthImg')} ${maxWidth}x${maxHeight}px`,
							'error',
							5000
						);
					}
				} else {
					handleNotify(
						messageMinError === ''
							? `${t('inputImgBigger.minWidthImg')} ${minWidth}x${minHeight}px`
							: `${messageMinError} ${minWidth}x${minHeight}px`,
						'error',
						5000
					);
				}
				setIsOpenLoad(false);
				setMessage('');
			};
		};
	}

	return (
		<S.container>
			{doubtBox && messageDoubtBox !== '' && (
				<S.doubtConatiner title={messageDoubtBox}>
					<BsQuestionCircle />
				</S.doubtConatiner>
			)}

			<S.inputImg>
				<p>{label}</p>
				<input
					type="file"
					name={idImagem}
					id={idImagem}
					accept="image/png, image/jpeg, image/jpg"
					onChange={(event) => {
						if (event.target.files!.length > 0) {
							savePhoto(event);
						}
					}}
				/>

				<S.labelWithImage>
					{initialImage !== '' &&
					initialImage !== null &&
					initialImage !== undefined ? (
						<S.imageLoadead
							onMouseOver={() => setIsShowBtnUnselect(true)}
							onMouseOut={() => setIsShowBtnUnselect(false)}
							onClick={() => {
								if (btnDeleteImage) {
									getImage('');
								}
							}}
							$imgHeight={imgHeight}
						>
							{btnDeleteImage && (
								<S.unselectImg $isShowBtnUnselect={isShowBtnUnselect}>
									<p>{t('inputImgBigger.delete')}</p>
								</S.unselectImg>
							)}

							<img src={initialImage} alt="ìcone" />
						</S.imageLoadead>
					) : (
						<S.noImage $imgHeight={imgHeight}>
							{legendDimensionsImage !== null && (
								<>
									<S.infoWidth>
										<p>{`${legendDimensionsImage.width} ${
											showMinLabel ? 'min' : ''
										} `}</p>
									</S.infoWidth>
									<S.infoheight>
										<p>{`${legendDimensionsImage.height} ${
											showMinLabel ? 'min' : ''
										}`}</p>
									</S.infoheight>
								</>
							)}
						</S.noImage>
					)}

					<label htmlFor={idImagem}>{t('inputImgBigger.choiceAFile')}</label>

					{showDelteImageFromBackBtn && (
						<S.deleteBtnFromBackBtn onClick={functionToDeleteImgFromBack}>
							<MdDelete color={color.interface.red} size={25} />
						</S.deleteBtnFromBackBtn>
					)}
				</S.labelWithImage>

				{error && <S.errorMessage>{t(messagemError)}</S.errorMessage>}
			</S.inputImg>
		</S.container>
	);
}
